import { render } from "./HeroiconsOutlineSearchCircle.vue?vue&type=template&id=ecc53f5e"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSearchCircle.vue"]])

export default __exports__